export default "__VITE_ASSET__BNzTjbrv__"